export const DefaultMessageTypes = {
    START_FOCUSE: 'START_FOCUSE',
    SET_FOCUSE: 'SET_FOCUSE'
};

export const DefaultDataTypes = {
    INIT: 'INIT'
};